export const ADD_ON_CONFIRM_COPY = {
  delete: {
    titleKey: "settings.add_ons.delete_title",
    messageKey: "settings.add_ons.delete_message",
    confirmKey: "settings.action_delete"
  },
  deactivate: {
    titleKey: "settings.add_ons.deactivate_title",
    messageKey: "settings.add_ons.deactivate_message",
    confirmKey: "settings.action_deactivate"
  },
  activate: {
    titleKey: "settings.add_ons.activate_title",
    messageKey: "settings.add_ons.activate_message",
    confirmKey: "settings.action_activate"
  }
}
